module.exports = __webpack_public_path__ + "static/mobile-ammohandgun-c637ca18e6eb2ea9687c7e409ec54fe9.png";